import styled from 'styled-components';

export const DefensivePlayerWrapper = styled.div`
  font-size: 13px;
`;
